<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <!-- <DataTable /> -->
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :disableSelectAllCheckbox="true"
    />
  </div>
</template>

<script>
// import DataTable from "@/own/components/warehouseManagement/fulfillmentTask/DataTable.vue";
import DataTable from "@/own/components/DataTable.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
} from "@/core/services/store/fulfillmentTasks.module";

export default {
  name: "FulfillmentTasks",
  components: { DataTable },
  data: () => ({
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
    },
    store_names: {
      getTableFilters: "getFULFILLMENTTASKSTableFilters",
      getTableState: "getFULFILLMENTTASKSTableState",
      getTableData: "getFULFILLMENTTASKSTableData",
      getTableHeaders: "getFULFILLMENTTASKSTableHeaders",
      getTableProperties: "getFULFILLMENTTASKSTableProperties",
      getTablePermissions: "getFULFILLMENTTASKSTablePermissions",
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return !!this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
